type TIconMap = {
  [key: string]: string;
};

const iconMap: TIconMap = {
  percent: 'saleRound',
  erecipe: 'eRecipe'
};

export const formatIcon = (icon: string): string =>
  iconMap[icon] || icon;
